module.exports = __webpack_public_path__ + "img/box7-4-4.df35f48f.png";